import { CancelablePromise, OpenAPI, Response } from "@/api";
import { request as __request } from "@/api/core/request";
import { ToDeleteRequest } from "@/utils/slice";
import { SupervisorAddRequest } from "@/api/models/supervisor/SupervisorAddRequest";
import { SupervisorListRequest } from "@/api/models/supervisor/SupervisorListRequest";
import { SupervisorListResponse } from "@/api/models/supervisor/SupervisorListResponse";
import { SupervisorUpdateRequest } from "@/api/models/supervisor/SupervisorUpdateRequest";

export class SupervisorService {
  public static Add(body: SupervisorAddRequest): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/admin/supervisor",
      body: body,
    });
  }

  public static Delete(body: number): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/admin/supervisor",
      body: ToDeleteRequest(body),
    });
  }

  public static Drop(body: number): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/admin/supervisor/drop",
      body: ToDeleteRequest(body),
    });
  }

  public static Update(
    body: SupervisorUpdateRequest
  ): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/admin/supervisor",
      body: body,
    });
  }

  public static ListAll(
    body: SupervisorListRequest
  ): CancelablePromise<SupervisorListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admin/supervisor",
      body: body,
    });
  }
}
